import SMFacilityLinkButton from './SMFacilityLinkButton';

export default SMFacilityLinkButton;
